/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ReassignmentListInfo { 
    /**
     * 主管改派案件 ProcessId
     */
    processInstanceId?: string;
    /**
     * 主管改派案件 TaskId
     */
    taskId?: string;
    /**
     * 被改派案件 ProcessId
     */
    reassigningProcessInstanceId?: string;
    /**
     * 被改派案件 ProcessDefinitionId
     */
    reassigningProcessDefinitionId?: string;
    /**
     * 被改派案件 ProcessDefKey
     */
    reassigningProcessDefKey?: string;
    /**
     * 被改派案件 ProcessName
     */
    reassigningProcessName?: string;
    /**
     * 被改派案件 TaskId
     */
    reassigningTaskId?: string;
    /**
     * 被改派案件 TaskName
     */
    reassigningTaskName?: string;
    /**
     * 指派者
     */
    assigner?: string;
    /**
     * 原處理者No
     */
    assignor?: string;
    /**
     * 原處理者Name
     */
    assignorName?: string;
    /**
     * 改派後處理者
     */
    assignee?: string;
    /**
     * 改派後處理者 DeptId
     */
    assigneeDeptId?: number;
}